import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultConversionInfo } from '../interfaces/ConversionIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface CB03ConversionDeleteProps {
  execConversionDelete: (deviceId: string, conversionText: string) => Promise<ResultConversionInfo>
  loading: loadStatus
}
// CB03 強制単語削除API呼出
export const useCB03ConversionDelete = (): CB03ConversionDeleteProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execConversionDelete = async (deviceId: string, conversionText: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.delete(
        `${buildDeviceUrl(deviceId, apiUrl.conversionsPath)}`,
        {
          headers: header,
          data: {
            pre_text: conversionText,
            language: 'ja',
          },
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execConversionDelete, loading }
}
